<template>
    <div class="course-detail">
        <div class="bg">
            <svg-icon icon-class="course"></svg-icon>
        </div>
        <div class="wdd">
            <div class="content">
                <div class="top-content">
                    <Row>
                        <i-col span="12">
                            <img src="@/assets/courseDetail/u1.png" alt="">
                        </i-col>
                        <i-col span="12">
                                <h5>少儿编程多维能力课 趣学系列启蒙班</h5>
                                <p>玩出聪明大脑，全面提升学习力</p>
                                <div>
                                    <span class="black">服务</span>
                                    <span>精选视频 / 及时答疑 / 及时回放</span>
                                </div>
                        </i-col>
                    </Row>
                </div>
                <div class="bottom-content">
                    <div class="title-item">
                        <span :class="type === 1 ? 'active' : ''" @click="type = 1">课程介绍</span>
                        <span :class="type === 2 ? 'active' : ''" @click="type = 2">课程目录</span>
                    </div>
                    <div v-show="type === 1">
                        <div class="part1">
                            <img src="@/assets/logo.png" alt="">
                            <h3>少儿编程启蒙训练课</h3>
                            <h6>快速提升编程能力</h6>
                            <div class="cbg">
                                <svg-icon icon-class="cbg"></svg-icon>
                                <ul>
                                    <li>适用于6-12岁孩子</li>
                                    <li>小班教学模式更加科学可靠</li>
                                    <li>多次思维提升训练</li>
                                    <li>名校教师团队开发课程</li>
                                </ul>
                            </div>
                        </div>
                        <div class="part2">
                            <h2>为什么学习少儿编程？</h2>
                            <h6>强化思维，高效学习</h6>
                            <div class="course-item item">
                                <Row>
                                    <i-col span="8">
                                        <img src="@/assets/courseDetail/i1.png" alt="">
                                    </i-col>
                                    <i-col span="15">
                                        <div class="title">
                                            <span class="blue">锻炼</span>数理思维
                                        </div>
                                        <p>编程比奥数更锻炼孩子的思维，学习理科更轻松</p>
                                    </i-col>
                                    <i-col span="8">
                                        <img src="@/assets/courseDetail/i2.png" alt="">
                                    </i-col>
                                    <i-col span="15">
                                        <div class="title">
                                            <span class="blue">培养</span>孩子专注力
                                        </div>
                                        <p>编程比奥数更锻炼孩子的思维，学习理科更轻松</p>
                                    </i-col>
                                    <i-col span="8">
                                        <img src="@/assets/courseDetail/i3.png" alt="">
                                    </i-col>
                                    <i-col span="15">
                                        <div class="title">
                                            <span class="blue">提升</span>解决问题能力
                                        </div>
                                        <p>编程比奥数更锻炼孩子的思维，学习理科更轻松</p>
                                    </i-col>
                                </Row>
                            </div>
                            <h2>为什么学习少儿编程？</h2>
                            <h6>强化思维，高效学习</h6>
                            <div class="item play">
                                <p>通过3节课互动学习，了解scratch的基本编程操作，并结合数学、物理、自然等相关知识，独立创作编程作品</p>
                                <Row type="flex" justify="center">
                                    <i-col span="11">
                                        <img class="hover-img"
                                            src="@/assets/home/games.png"
                                            alt />
                                        <p class="play-title">游戏化编程</p>
                                    </i-col>
                                    <i-col span="11">
                                        <svg-icon class="hover-img"
                                            icon-class="play"></svg-icon>
                                        <p class="play-title">提升竞争力</p>
                                    </i-col>
                                    <i-col span="11">
                                        <svg-icon class="hover-img" icon-class="app"></svg-icon>
                                        <p class="play-title">编写手机程序</p>
                                    </i-col>
                                    <i-col span="11">
                                        <svg-icon class="hover-img" icon-class="code"></svg-icon>
                                        <p class="play-title">掌握前沿编程</p>
                                    </i-col>
                                </Row>
                            </div>
                            <h2>课程特色</h2>
                            <div class="item list">
                                <div class="list-item">
                                    <div class="title">
                                        <span class="number">1</span>
                                        <span>双师小班互动，持续专注</span>
                                    </div>
                                    <svg-icon icon-class="course1"></svg-icon>
                                </div>
                                <div class="list-item">
                                    <div class="title">
                                        <span class="number">2</span>
                                        <span>双师小班互动，持续专注</span>
                                    </div>
                                    <svg-icon icon-class="course2"></svg-icon>
                                </div>
                                <div class="list-item">
                                    <div class="title">
                                        <span class="number">3</span>
                                        <span>双师小班互动，持续专注</span>
                                    </div>
                                    <img src="@/assets/courseDetail/u193.jpg" alt="">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-show="type === 2" class="type2">
                        <div class="type-item">
                            <Row type="flex" justify="space-between">
                                <i-col class="number">第一课</i-col>
                                <i-col>
                                    <span class="dashed">8.13开课</span>
                                </i-col>
                            </Row>
                            <div class="word-content">涂鸦机器人</div>
                            <Row type="flex" justify="space-between">
                                <i-col>
                                    <span class="attend">上课</span>
                                    <span class="title">少儿编程机器人课系列之《涂鸦机器人</span>
                                </i-col>
                                <i-col>
                                    <span class="time">未开始上课  8月13日 9：30-10：30</span>
                                </i-col>
                            </Row>
                        </div>
                        <div class="type-item">
                            <Row type="flex" justify="space-between">
                                <i-col class="number">第二课</i-col>
                                <i-col>
                                    <span class="dashed">8.13开课</span>
                                </i-col>
                            </Row>
                            <div class="word-content">涂鸦机器人</div>
                            <Row type="flex" justify="space-between">
                                <i-col>
                                    <span class="attend">上课</span>
                                    <span class="title">少儿编程机器人课系列之《涂鸦机器人</span>
                                </i-col>
                                <i-col>
                                    <span class="time">未开始上课  8月13日 9：30-10：30</span>
                                </i-col>
                            </Row>
                        </div>
                        <div class="type-item">
                            <Row type="flex" justify="space-between">
                                <i-col class="number">第三课</i-col>
                                <i-col>
                                    <span class="dashed">8.13开课</span>
                                </i-col>
                            </Row>
                            <div class="word-content">涂鸦机器人</div>
                            <Row type="flex" justify="space-between">
                                <i-col>
                                    <span class="attend">上课</span>
                                    <span class="title">少儿编程机器人课系列之《涂鸦机器人</span>
                                </i-col>
                                <i-col>
                                    <span class="time">未开始上课  8月13日 9：30-10：30</span>
                                </i-col>
                            </Row>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="fixed-content">
            <Row>
                <i-col span="4" class="title">期次</i-col>
                <i-col span="20"><span class="qi">初级班666期</span></i-col>
            </Row>
            <Row>
                <i-col span="4" class="title">说明</i-col>
                <i-col span="20">
                    <p>上课时间：7月13日-8月13日 9：30开课</p>
                    <p>上课方式：小班教学+拓展训练+电业点评+课后辅导</p>
                </i-col>
            </Row>
            <Row style="border-bottom: none;">
                <i-col span="4" class="title">价格</i-col>
                <i-col span="20"><span class="price">¥1999</span></i-col>
            </Row>
            
            <Poptip width="200" placement="bottom">
                <Button type="error" class="btn">立即参加</Button>
                  <div class="api" slot="content">
                      <img src="@/assets/common/logo.png" alt="">
                  </div>
                </Poptip>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            type: 1,
        }
    }
}
</script>
<style lang="scss" scoped>
.course-detail{
    margin-top: -70px;
    padding-top: 70px;
    position: relative;
    overflow-x: hidden;
    .bg{
        width: 2208px;
        height: 449px;
        svg{
            position: absolute;
            top: 0;
            left: 0;
            z-index: 1;
            width: 2208px;
            height: 449px;
        }
    }
    .wdd{
        width: 1080px;
        margin: 0 auto;
    }
    .content{
        position: relative;
        z-index: 999;
        width: 699px;
        text-align: left;
        margin-top: -400px;
        .top-content{
            background: #fff;
            padding: 20px;
            img{
                width: 300px;
                height: 169px;
            }
            h5{
                font-size: 24px;
                color: #333;
            }
            p, span{
                color: #ccc;
                font-size: 13px;
            }
            p{
                line-height: 30px;
                margin-bottom: 10px;
            }
            span:hover{
                text-decoration: underline;
            }
            .black{
                color: #000;
            }
        }
        .bottom-content{
            background: #fff;
            margin-top: 30px;
            padding: 0 20px;
            .title-item{
                margin: 0 -20px 20px;
                background: #fafafa;
                font-size: 18px;
                color: #B2D4FA;
                width: 100%;
                span{
                    width: 152px;
                    line-height: 50px;
                    display: inline-block;
                    text-align: center;
                    cursor: pointer;
                    &:first-child{
                        padding-left: 30px;
                    }
                    &:hover{
                        color: #666;
                    }
                }
                .active{
                    border-top: 2px solid #ddd;
                    background: #fff;
                    color: #54C3D4;
                    &:hover{
                        color: #54C3D4;
                    }
                }
            }
        }
        .part1{
            padding: 10px 20px 30px 30px;
            background: linear-gradient(180deg, rgba(60, 131, 237, 1) 0%, rgba(84, 204, 226, 1) 99%);
            color: #fff;
            text-align: center;
            h3{
                margin-top: 20px;
                font-size: 60px;
                font-weight: 400;
            }
            h6{
                font-size: 36px;
            }
            .cbg{
                margin-top: 50px;
                width: 375px;
                height: 170px;
                position: relative;
                svg{
                    width: 375px;
                    height: 170px;
                }
                ul{
                    position: absolute;
                    top: 15px;
                    left: 20px;
                    margin-left: 30px;
                    text-align: left;
                    li{
                        line-height: 35px;
                        font-size: 20px;
                        list-style: disc;
                    }
                }
            }
        }
        .part2{
            padding-top: 30px;
            padding-bottom: 20px;
            background-color: rgba(255, 253, 247, 1);
            h2{
                text-align: center;
                font-size: 36px;
                color: rgb(72, 167, 232);
            }
            h6{
                text-align: center;
                font-size: 28px;
                color: #333;
            }
            .item{
                margin: 10px auto 30px;
                padding: 20px;
                width: 562px;
                background-color: rgba(255, 255, 255, 1);
                box-shadow: 5px 5px 5px rgba(184, 184, 184, 1);
            }
            .course-item {
                img{
                    width: 128px;
                    height: 128px;
                }
                .title{
                    font-size: 28px;
                    margin: 10px 0;
                    .blue{
                        color: #48A7E8;
                    }
                }
                p{
                    margin-bottom: 68px;
                    font-size: 20px;
                    color: #B8B7B8;
                }
            }
            .play{
                font-size: 24px;
                text-align: center;
                > p{
                    font-size: 24px;
                    text-align: left;
                    margin-bottom: 30px;
                }
                .hover-img{
                    width: 110px;
                    height: 110px;
                }
                .play-title{
                    font-weight: 700;
                    font-size: 20px;
                    margin-bottom: 30px;
                }
            }
        }
        .list{
            .list-item{
                .title{
                    margin-top: 38px;
                    margin-bottom: 20px;
                    .number{
                        background: #48a7e7;
                        color: #fff;
                        display: inline-block;
                        width: 30px;
                        height: 30px;
                        text-align: center;
                        line-height: 30px;
                        border-radius: 50%;
                    }
                    span{
                        font-size: 20px;
                        color: #333;
                    }
                }
                svg, img{
                    width: 495px;
                    height: 288px;
                }
            }
        }
        .type2{
            padding-bottom: 30px;
            .type-item{
                padding: 20px 0;
                border-bottom: 1px solid #ccc;
                .number{
                    font-size: 16px;
                    color: #333;
                }
                .dashed{
                    border: 1px dashed #ACD577;
                    color: #ACD577;
                    font-size: 13px;
                    padding: 0 10px;
                }
                .word-content{
                    margin-top: 10px;
                    margin-bottom: 20px;
                    font-size: 16px;
                    padding: 10px;
                    background-color: rgba(243, 243, 243, 1);
                }
                .attend{
                    border: 1px solid #ccc;
                    color: #CCCCCC;
                    padding: 0 5px;
                    margin-right: 15px;
                }
                .time{
                    font-size: 13px;
                    color: #ccc;
                }
            }
            
        }
    }
    .fixed-content{
        width: 300px;
        background: #fff;
        z-index: 9999;
        position: fixed;
        top: 100px;
        right: 100px;
        padding: 10px 20px;
        .title {
            color: #000;
            font-size: 13px;
        }
        .price{
            font-size: 28px;
            color: rgb(255, 88, 104);
            font-weight: 700;
        }
        p{
            color: rgb(204, 204, 204);
        }
        .qi{
            background-color: rgb(84, 195, 212);
            line-height: 29px;
            color: #fff;
            text-align: center;
            display: inline-block;
            padding: 4px 10px;
            border-radius: 4px;
            margin-top: -6px;
        }
        span{
            vertical-align: middle;
        }
    }
}
</style>
<style lang="scss">
.fixed-content {
    .ivu-row{
        border-bottom: 1px solid #ddd;
        padding: 15px 0;
        text-align: left;
    }
    .btn{
        background-color: rgb(255, 88, 104);
        width: 170px;
        height: 44px;
        font-size: 15px;
    }
    .api{
        img{
            width: 100%;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/views/home/courseDetail.vue